module.exports = {"basicInfo":"Basic Info","sales_username":"Sales Person","guide_phone":"Tour Guide Phone Number","tour_number":"Tour No.","itineray":"Upload Itineray File","note":"Remark","start_date":"Start Date","end_date":"End Date","textForIti":"Choose Itenarary File","textForButton":"Upload"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/components/grouptour/create/information.json
// module id = XP28
// module chunks = 58